import { VehicleInformation } from "../data/VehInfo";

const Ammunition = (options) => {
    const { type, capacity } = options;
    const className = "veh-ammunition";

    return (
        <div className={className}>
            <h2 className="veh-ammunition-title">Ammunition</h2>
            <table>
                <tr>
                    <td>Type:</td>
                    <td>{type}</td>
                </tr>
                <tr>
                    <td>Capacity:</td>
                    <td>{capacity}</td>
                </tr>
            </table>
        </div>
    )
}

export default Ammunition;